import { createSelector } from '@ngrx/store';
import * as staticDataState from '../static-data.reducer';
import * as asqFundsReducer from '../reducers/asq-funds.reducer';

export const selectAsqFunds = createSelector(
  staticDataState.selectAsqFundsState,
  asqFundsReducer.getAsqFunds
);
